var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook2S(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 22,
    viewBox: "0 0 15 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.686H9.892V7.26c0-1.287.834-1.587 1.42-1.587h3.606V.02L9.953 0C4.442 0 3.187 4.217 3.187 6.916v3.77H0v5.826h3.187V33h6.705V16.512h4.523L15 10.686z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNSAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDEwLjY4NTZIOS44OTE1M1Y3LjI2MDU1QzkuODkxNTMgNS45NzQyOSAxMC43MjU1IDUuNjc0NDIgMTEuMzEyOCA1LjY3NDQyQzExLjg5ODggNS42NzQ0MiAxNC45MTc4IDUuNjc0NDIgMTQuOTE3OCA1LjY3NDQyVjAuMDE5ODA5Nkw5Ljk1MyAxLjMyODk1ZS0wN0M0LjQ0MTYgMS4zMjg5NWUtMDcgMy4xODczNyA0LjIxNzM5IDMuMTg3MzcgNi45MTYyN1YxMC42ODU2SDIuMzQ1MWUtMDdWMTYuNTEyM0gzLjE4NzM3QzMuMTg3MzcgMjMuOTkwMSAzLjE4NzM3IDMzIDMuMTg3MzcgMzNIOS44OTE1M0M5Ljg5MTUzIDMzIDkuODkxNTMgMjMuOTAxMyA5Ljg5MTUzIDE2LjUxMjNIMTQuNDE1M0wxNSAxMC42ODU2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgFacebook2S as ReactComponent };